import { gray, green, red, yellow, azure, orange, purple, blue } from '../colors-experimental.mjs';
import { createMetaThemeVariant, createMetaThemeVariantPartial } from './utils.mjs';

var metaThemeLightUpliftPartial = createMetaThemeVariantPartial({
  motion: {
    'motion-ease-out': {
      value: 'cubic-bezier(0.19, 0.91, 0.38, 1)'
    }
  },
  font: {
    'font-family-sans': {
      value: "'Inter', -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif"
    },
    'font-size-500': {
      value: '30px'
    },
    'font-size-600': {
      value: '36px'
    }
  },
  shadow: {
    'shadow-inset-lg': {
      value: 'inset -1px 0px 1px rgba(0, 0, 0, 0.2), inset 1px 0px 1px rgba(0, 0, 0, 0.2), inset 0px 2px 1px rgba(0, 0, 0, 0.6)'
    },
    'shadow-inset-md': {
      value: 'inset -1px 0px 1px rgba(0, 0, 0, 0.12), inset 1px 0px 1px rgba(0, 0, 0, 0.12), inset 0px 2px 1px rgba(0, 0, 0, 0.2)'
    },
    'shadow-inset-sm': {
      value: 'inset 0px 1px 1px rgba(0, 0, 0, 0.15), inset 0px 1px 2px rgba(255, 255, 255, 0.15)'
    },
    'shadow-xs': {
      value: '0px 1px 0px rgba(0, 0, 0, 0.07)'
    },
    'shadow-sm': {
      value: '0px 3px 1px -1px rgba(0, 0, 0, 0.07)'
    },
    'shadow-md': {
      value: '0px 4px 6px -2px rgba(0, 0, 0, 0.2)'
    },
    'shadow-lg': {
      value: '0px 8px 16px -4px rgba(0, 0, 0, 0.22)'
    },
    'shadow-xl': {
      value: '0px 12px 20px -8px rgba(0, 0, 0, 0.24)'
    },
    'shadow-2xl': {
      value: '0px 20px 20px -8px rgba(0, 0, 0, 0.28)'
    }
  },
  color: {
    'color-bg-inverse': {
      value: gray[16]()
    },
    'color-bg-inset-strong': {
      value: gray[15]()
    },
    'color-bg-inverse-hover': {
      value: gray[14]()
    },
    'color-bg-inverse-active': {
      value: gray[13]()
    },
    'color-bg-strong-hover': {
      value: gray[9]()
    },
    'color-bg-strong-active': {
      value: gray[10]()
    },
    'color-bg-strong': {
      value: gray[8]()
    },
    'color-bg-subdued-active': {
      value: gray[7]()
    },
    'color-bg-disabled': {
      value: gray[7]()
    },
    'color-bg-interactive-disabled': {
      value: gray[7]()
    },
    'color-bg-app': {
      value: gray[6]()
    },
    'color-bg-app-hover': {
      value: gray[2]()
    },
    'color-bg-app-selected': {
      value: gray[3]()
    },
    'color-bg-active': {
      value: gray[4]()
    },
    'color-bg-subdued-hover': {
      value: gray[6]()
    },
    'color-bg-inset': {
      value: gray[6]()
    },
    'color-bg-hover': {
      value: gray[3]()
    },
    'color-bg-subdued': {
      value: gray[4]()
    },
    'color-bg-input': {
      value: gray[1]()
    },
    'color-bg': {
      value: gray[1]()
    },
    'color-bg-primary-active': {
      value: gray[16]()
    },
    'color-bg-primary-hover': {
      value: gray[16]()
    },
    'color-bg-primary': {
      value: gray[15]()
    },
    'color-bg-success-strong': {
      value: green[12]
    },
    'color-bg-success': {
      value: green[3]
    },
    'color-bg-primary-subdued-active': {
      value: gray[6]()
    },
    'color-bg-success-subdued': {
      value: green[3]
    },
    'color-bg-primary-subdued-hover': {
      value: gray[7]()
    },
    'color-bg-success-subdued-hover': {
      value: green[5]
    },
    'color-bg-primary-subdued': {
      value: gray[8]()
    },
    'color-bg-primary-subdued-selected': {
      value: gray[6]()
    },
    'color-bg-critical-strong-active': {
      value: red[14]
    },
    'color-bg-critical-strong-hover': {
      value: red[13]
    },
    'color-bg-critical-strong': {
      value: red[12]
    },
    'color-bg-critical-subdued-active': {
      value: red[6]
    },
    'color-bg-critical': {
      value: red[6]
    },
    'color-bg-critical-subdued': {
      value: red[4]
    },
    'color-bg-critical-subdued-hover': {
      value: red[5]
    },
    'color-bg-caution-strong': {
      value: yellow[6]
    },
    'color-bg-caution': {
      value: yellow[4]
    },
    'color-bg-caution-subdued-active': {
      value: yellow[4]
    },
    'color-bg-caution-subdued': {
      value: yellow[2]
    },
    'color-bg-caution-subdued-hover': {
      value: yellow[3]
    },
    'color-bg-info-strong': {
      value: azure[9]
    },
    'color-bg-info-subdued-active': {
      value: azure[6]
    },
    'color-bg-info': {
      value: azure[4]
    },
    'color-bg-info-subdued': {
      value: azure[3]
    },
    'color-bg-info-subdued-hover': {
      value: azure[4]
    },
    'color-bg-interactive-active': {
      value: gray[14]()
    },
    'color-bg-interactive-hover': {
      value: gray[15]()
    },
    'color-bg-interactive': {
      value: gray[16]()
    },
    'color-bg-interactive-subdued-active': {
      value: gray[6]()
    },
    'color-bg-interactive-subdued-hover': {
      value: gray[7]()
    },
    'color-bg-interactive-subdued': {
      value: gray[8]()
    },
    'color-bg-interactive-selected': {
      value: gray[6]()
    },
    'color-bg-warning': {
      value: orange[7]
    },
    'color-bg-magic-strong': {
      value: purple[12]
    },
    'color-bg-magic-hover': {
      value: purple[7]
    },
    'color-bg-magic-active': {
      value: purple[8]
    },
    'color-bg-magic': {
      value: purple[6]
    },
    'color-bg-magic-subdued-hover': {
      value: purple[4]
    },
    'color-bg-magic-subdued-active': {
      value: purple[6]
    },
    'color-bg-magic-subdued': {
      value: purple[3]
    },
    'color-border-input-hover': {
      value: gray[13]()
    },
    'color-border-inverse': {
      value: gray[13]()
    },
    'color-border-strong-hover': {
      value: gray[11]()
    },
    'color-border-input': {
      value: gray[12]()
    },
    'color-border-hover': {
      value: gray[10]()
    },
    'color-border-strong': {
      value: gray[10]()
    },
    'color-border': {
      value: gray[8]()
    },
    'color-border-disabled': {
      value: gray[7]()
    },
    'color-border-subdued': {
      value: gray[7]()
    },
    'color-border-interactive-disabled': {
      value: gray[7]()
    },
    'color-border-primary': {
      value: gray[8]()
    },
    'color-border-success': {
      value: green[5]
    },
    'color-border-success-subdued': {
      value: green[5]
    },
    'color-border-critical-active': {
      value: red[11]
    },
    'color-border-critical-hover': {
      value: red[10]
    },
    'color-border-critical': {
      value: red[9]
    },
    'color-border-critical-subdued': {
      value: red[9]
    },
    'color-border-caution': {
      value: yellow[5]
    },
    'color-border-caution-subdued': {
      value: yellow[5]
    },
    'color-border-info': {
      value: azure[9]
    },
    'color-border-info-subdued': {
      value: azure[9]
    },
    'color-border-interactive-active': {
      value: blue[15]
    },
    'color-border-interactive-hover': {
      value: blue[14]
    },
    'color-border-interactive': {
      value: blue[13]
    },
    'color-border-interactive-focus': {
      value: blue[13]
    },
    'color-border-interactive-subdued': {
      value: blue[13]
    },
    'color-border-magic-strong': {
      value: purple[12]
    },
    'color-border-magic': {
      value: purple[10]
    },
    'color-icon-hover': {
      value: gray[15]()
    },
    'color-icon': {
      value: gray[14]()
    },
    'color-icon-subdued': {
      value: gray[12]()
    },
    'color-icon-disabled': {
      value: gray[10]()
    },
    'color-icon-interactive-disabled': {
      value: gray[10]()
    },
    'color-icon-inverse': {
      value: gray[8]()
    },
    'color-icon-on-color': {
      value: gray[1]()
    },
    'color-icon-primary': {
      value: gray[16]()
    },
    'color-icon-success': {
      value: green[12]
    },
    'color-icon-critical': {
      value: red[11]
    },
    'color-icon-caution': {
      value: yellow[11]
    },
    'color-icon-info': {
      value: azure[11]
    },
    'color-icon-warning': {
      value: orange[11]
    },
    'color-icon-interactive-active': {
      value: blue[15]
    },
    'color-icon-interactive-hover': {
      value: blue[14]
    },
    'color-icon-interactive': {
      value: blue[13]
    },
    'color-icon-interactive-inverse': {
      value: blue[8]
    },
    'color-icon-magic': {
      value: purple[13]
    },
    'color-text': {
      value: gray[15]()
    },
    'color-text-subdued': {
      value: gray[13]()
    },
    'color-text-disabled': {
      value: gray[11]()
    },
    'color-text-interactive-disabled': {
      value: gray[10]()
    },
    'color-text-inverse-subdued': {
      value: gray[10]()
    },
    'color-text-inverse': {
      value: gray[8]()
    },
    'color-text-on-color': {
      value: gray[1]()
    },
    'color-text-success-strong': {
      value: green[15]
    },
    'color-text-success': {
      value: green[15]
    },
    'color-text-primary': {
      value: gray[14]()
    },
    'color-text-primary-hover': {
      value: gray[14]()
    },
    'color-text-critical-strong': {
      value: red[14]
    },
    'color-text-critical-active': {
      value: red[16]
    },
    'color-text-critical': {
      value: red[14]
    },
    'color-text-caution-strong': {
      value: yellow[15]
    },
    'color-text-caution': {
      value: yellow[15]
    },
    'color-text-info-strong': {
      value: azure[16]
    },
    'color-text-info': {
      value: azure[14]
    },
    'color-text-warning-strong': {
      value: orange[16]
    },
    'color-text-interactive-active': {
      value: blue[15]
    },
    'color-text-interactive-hover': {
      value: blue[14]
    },
    'color-text-interactive': {
      value: blue[13]
    },
    'color-text-interactive-inverse': {
      value: blue[8]
    },
    'color-text-magic-strong': {
      value: purple[15]
    },
    'color-text-magic': {
      value: purple[14]
    }
  }
});
createMetaThemeVariant(metaThemeLightUpliftPartial);

export { metaThemeLightUpliftPartial };
